module.exports = __webpack_public_path__ + "static/media/galerija_2021 (22).9947ddb7.jpg";